export const UNKNOWN = 'unknown';
export const CONNECTED = 'connected';
export const NOT_AUTHORIZED = 'not_authorized';
